/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuoteRequestApiDto } from './quote-request.model';
import { QuoteLeadAnalyticsDataApiDto } from './quote-lead-analytics-data.model';
import { QuoteLeadUserDataApiDto } from './quote-lead-user-data.model';

export interface QuoteLeadApiDto {
  formOrigin?: QuoteLeadApiDto.FormOriginEnum;
  quoteRequest?: Array<QuoteRequestApiDto>;
  leadUserData?: QuoteLeadUserDataApiDto;
  id?: number;
  analyticsData?: QuoteLeadAnalyticsDataApiDto;
}
export namespace QuoteLeadApiDto {
  export const FormOriginEnum = {
    PRICE_REQUEST: 'PRICE_REQUEST',
    QUICK_QUOTE: 'QUICK_QUOTE',
    ENROLMENT: 'ENROLMENT',
    ONLINE_COURSES_ENROLMENT: 'ONLINE_COURSES_ENROLMENT',
    ENGLISH_TEST: 'ENGLISH_TEST',
    ARGO_QUICK_QUOTE_TOOL: 'ARGO_QUICK_QUOTE_TOOL',
    AYA_QUOTE: 'AYA_QUOTE',
  } as const;
  export type FormOriginEnum = (typeof FormOriginEnum)[keyof typeof FormOriginEnum];
}
